module.exports = __webpack_public_path__ + "img/logo.506e9a82.svg";